import React, { useMemo, useState, type ReactNode } from 'react';
import { LessonDetailsModal } from '@/components/LessonDetailsModal';
import { LessonDetailsMode } from '@/types/components';
import { EvaluationModalContext } from '@/components/EvaluationModal/context';

interface Props {
  children: ReactNode;
}

export const EvaluationModalProvider: React.FC<Props> = ({ children }) => {
  const [evaluationId, setEvaluationId] = useState<number | null>(null);

  const value = useMemo(() => ({ onOpen: setEvaluationId }), []);

  return (
    <EvaluationModalContext.Provider value={value}>
      {children}
      {evaluationId !== null && (
        <LessonDetailsModal
          mode={LessonDetailsMode.Evaluation}
          evaluationId={evaluationId}
          onClose={() => setEvaluationId(null)}
        />
      )}
    </EvaluationModalContext.Provider>
  );
};
